/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { useMemo } from 'react';
import { useState } from 'react';
import { useRef } from 'react';
import { useCallback } from 'react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import { PermissionsContext } from 'contexts/PermissionsContext';
import createDatasource from './ServerSideDataSource';
import { ApSimpleSearch } from '@alixpartners/ui-components';
import { TableWrapper, SearchWrapper } from './AgDropDown.style';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';

const AgDropDown = ({ selectedFilter, handleChange, selectedItems }) => {
	const {
		currentSelectCategory,
		isSourceable,
		isDirect,
		taxonomyType,
		dateRangeData,
	} = useContext(CategoryManagementContext);
	const gridStyle = useMemo(
		() => ({
			height: '375px',
			width: '100%',
		}),
		[]
	);
	const [searchterm, setSearchterm] = useState('');
	const defaultColDefs = useMemo(() => {
		return {
			flex: 1,
			minWidth: 100,
		};
	}, []);

	const gridRef = useRef();
	const [columnDefs] = useState([
		{
			headerName: '',
			field: selectedFilter,
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: selectedFilter,
			filter: 'agTextColumnFilter',
			checkboxSelection: true,
		},
	]);

	const handleCellRefresh = useCallback(
		() => {
			const selectedValues = gridRef.current.api
				.getSelectedRows()
				.map(data => data[selectedFilter]);
			if (
				selectedItems.length === selectedValues.length &&
				new Set([...selectedItems, ...selectedValues]).size ===
					selectedItems.length
			) {
				return;
			}

			handleChange(selectedValues);
		},
		[gridRef, selectedFilter, selectedItems, handleChange]
	);

	const [gridOptions] = useState({
		modules: AllModules,
		columnDefs: columnDefs,
		cacheBlockSize: 200,
		maxBlocksInCache: 10,
		enableFilter: true,
		rowModelType: 'serverSide',
		rowHeight: 70,
		maxConcurrentDatasourceRequests: 4,
		suppressCutToClipboard: true,
		getRowNodeId: item => item.id,
		rowSelection: 'multiple',
		suppressCopyRowsToClipboard: true,
		suppressScrollOnNewData: true,
		suppressRowHoverHighlight: true,
		suppressRowDrag: true,
		suppressRowClickSelection: true,
		suppressCellSelection: true,
		suppressCsvExport: true,
		suppressExcelExport: true,
		suppressContextMenu: true,
		suppressMultiSort: true,
		suppressNoRowsOverlay: true,
	});
	const onGridReady = useCallback(
		params => {
			const gridOptionsnew = {
				columnDefs,
				suppressRowClickSelection: true,
				...gridOptions,
				params: params,
				selectedItems: selectedItems,
				getRowNodeId: item => item.id,
				selectedFilter: selectedFilter,
				newFilters: {
					currentSelectCategory,
					isSourceable,
					isDirect,
					taxonomyType,
					dateRangeData,
					searchterm,
					selectedFilter,
				},
			};
			const datasource = createDatasource(gridOptionsnew);
			params.api.setServerSideDatasource(datasource);
		},
		[columnDefs, gridOptions]
	);

	useEffect(
		() => {
			const gridOptionsnew = {
				columnDefs,
				suppressRowClickSelection: true,
				...gridOptions,
				params: gridRef.current,
				selectedItems: selectedItems,
				getRowNodeId: item => item.id,
				selectedFilter: selectedFilter,
				newFilters: {
					currentSelectCategory,
					isSourceable,
					isDirect,
					taxonomyType,
					dateRangeData,
					searchterm,
					selectedFilter,
				},
			};
			const datasource = createDatasource(gridOptionsnew);
			gridRef.current.api.setServerSideDatasource(datasource);
		},
		[searchterm]
	);

	const debounce = (func, delay) => {
		let timeoutId;
		return (...args) => {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
				func.apply(null, args);
			}, delay);
		};
	};

	const handleSearchGraphql = value => {
		setSearchterm(value);
	};

	const debouncedHandleSearchGraphql = debounce(handleSearchGraphql, 300);

	const onFirstDataRendered = () => {
		let idSequence = 0;
		gridRef.current.api.forEachNode(function(rowNode, _) {
			rowNode.id = idSequence++;
		});
		gridRef.current.api.forEachNode(node => {
			if (node.data && selectedItems.includes(node.data[selectedFilter])) {
				node.setSelected(true);
			}
		});
	};

	return (
		<div>
			<SearchWrapper>
				<ApSimpleSearch
					id="filters-search"
					onChange={value => debouncedHandleSearchGraphql(value)}
					onClear={() => setSearchterm('')}
				/>
			</SearchWrapper>
			<TableWrapper>
				<div style={gridStyle} className="ag-theme-balham">
					<AgGridReact
						ref={gridRef}
						modules={AllModules}
						columnDefs={columnDefs}
						cacheBlockSize={200}
						defaultColDef={defaultColDefs}
						maxBlocksInCache={10}
						rowModelType="serverSide"
						maxConcurrentDatasourceRequests={4}
						onGridReady={onGridReady}
						suppressCutToClipboard={true}
						rowSelection={'multiple'}
						getRowNodeId={item => item.id}
						onSelectionChanged={handleCellRefresh}
						suppressRowClickSelection={true}
						onFirstDataRendered={onFirstDataRendered}
						suppressCopyRowsToClipboard={true}
						suppressScrollOnNewData={true}
						suppressRowHoverHighlight={true}
						suppressRowDrag={true}
						suppressCellSelection={true}
						suppressCsvExport={true}
						suppressExcelExport={true}
						suppressContextMenu={true}
						suppressMultiSort={true}
						suppressNoRowsOverlay={true}
					/>
				</div>
			</TableWrapper>
		</div>
	);
};

export default props => (
	<PermissionsContext.Consumer>
		{({ permissions }) => (
			<AgDropDown {...props} permissions={permissions || []} />
		)}
	</PermissionsContext.Consumer>
);
